import "./SotGa4PendingSegmentationChanges.scss";
import * as R from "ramda";
import { MdClose } from "react-icons/md";
import { SotGa4EditsMap, SotGa4EditsMapAction } from "./SotGa4Labeling";
import { CustomSegmentsData } from "./SotGa4MappingTool";

interface SotGa4PendingSegmentationChangesProps {
  incompleteUnlabeledEditsMap: SotGa4EditsMap;
  completeUnlabeledEditsMap: SotGa4EditsMap;
  labeledEditsMap: SotGa4EditsMap;
  dispatchUnlabeledEditsMap: React.Dispatch<SotGa4EditsMapAction>;
  dispatchLabeledEditsMap: React.Dispatch<SotGa4EditsMapAction>;
  setShowPendingChanges: React.Dispatch<React.SetStateAction<boolean>>;
  customSegments: CustomSegmentsData[] | undefined;
}

const SotGa4PendingSegmentationChanges: React.FC<SotGa4PendingSegmentationChangesProps> = ({
  incompleteUnlabeledEditsMap,
  completeUnlabeledEditsMap,
  labeledEditsMap,
  dispatchUnlabeledEditsMap,
  dispatchLabeledEditsMap,
  setShowPendingChanges,
}) => {
  const renderEditsSection = (
    editsMap: SotGa4EditsMap,
    title: string,
    dispatchEditsMap: React.Dispatch<SotGa4EditsMapAction>,
    showWarning?: boolean
  ) => {
    if (R.isEmpty(editsMap)) {
      return null;
    }

    return (
      <div className={`${showWarning ? "unlabeledSection" : "labeledSection"}`}>
        <span className="editsTitle">
          {title}
          {showWarning && (
            <div className="warningText">
              *These will not be saved until all segments are completed
            </div>
          )}
        </span>
        {R.keys(editsMap).map(key => {
          const row = editsMap[key];
          return (
            <div key={key} className="pendingEditItem">
              <div className="campaignInfo">
                <strong>Campaign:</strong> {row.campaign_name || row.campaign_id || "Unknown"}
                {row.ad_group_name && <span> | Ad Group: {row.ad_group_name}</span>}
                {row.ad_name && <span> | Ad: {row.ad_name}</span>}
              </div>
              <div className="segmentEdits">
                {row.edits &&
                  Object.entries(row.edits).map(([segmentName, edit]) => {
                    if (!edit) {
                      return null;
                    }

                    return (
                      <div key={segmentName} className="segmentEdit">
                        <span className="segmentName">{segmentName}:</span>
                        <span className="segmentValue">{edit.value}</span>
                        <button
                          className="removeEdit"
                          onClick={() => {
                            dispatchEditsMap({
                              type: "DELETE_SEGMENT_EDIT",
                              campaign_keys: [String(key)],
                              segmentName,
                            });
                          }}
                        >
                          <MdClose />
                        </button>
                      </div>
                    );
                  })}
              </div>
            </div>
          );
        })}
      </div>
    );
  };

  return (
    <div className="pendingSegmentationChangesContainer">
      <div className="pendingSegmentationChangesHeader">
        Pending Changes
        <div className="closeButton" onClick={() => setShowPendingChanges(false)}>
          <MdClose />
        </div>
      </div>
      <div className="pendingSegmentationChangesBody">
        {renderEditsSection(
          incompleteUnlabeledEditsMap,
          "Incomplete segments",
          dispatchUnlabeledEditsMap,
          true
        )}
        {renderEditsSection(
          completeUnlabeledEditsMap,
          "Newly assigned segments",
          dispatchUnlabeledEditsMap
        )}
        {renderEditsSection(labeledEditsMap, "Segment updates", dispatchLabeledEditsMap, true)}
      </div>
    </div>
  );
};

export default SotGa4PendingSegmentationChanges;
